<dsp-content-card [types]="filterTypes$ | async" [loading]="loading$ | async">
  <atlas-field-select [style.--radius-xsmall]="'4px'" [fullWidth]="(isMobile$ | async)" [widthValue]="270"
    [size]="(isMobile$ | async) ? sizeSmall : sizeMedium" *dsp-content-filter id="performance-option-filter"
    [label]="'Select Your Option'" [disabled]="!(funds$ | async).length" placeholder="Pick One"
    [multiselectable]="false" [options]="optionFilterOptions" (valueChange)="onChangeOption($event)"
    [(ngModel)]="option" [clearable]="false">
  </atlas-field-select>

  <ng-container *ngIf="!(isMobile$ | async)">
    <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [size]="sizeMedium" *dsp-content-filter
      id="performance-fund-filter" [label]="'Fund'" placeholder="Pick One" [multiselectable]="false"
      [options]="fundFilterOptions$ | async" [(ngModel)]="fund" [disabled]="!(funds$ | async).length"
      (valueChange)="onChangeFund($event)" [clearable]="false"
      [style.--semanticColor-text-placeholder]="'var(--semanticColor-text-default)'">
    </atlas-field-select>


    <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [size]="sizeMedium" *dsp-content-filter
      id="performance-year-filter" [label]="'As At Year'" placeholder="Pick One" [multiselectable]="false"
      [options]="yearFilterOptions$ | async" [disabled]="!(years$ | async).length" [(ngModel)]="year"
      (valueChange)="onChangeYear($event)" [clearable]="false">
    </atlas-field-select>

    <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [size]="sizeMedium" *dsp-content-filter
      id="performance-month-filter" [label]="'As At Month'" placeholder="Pick One" [multiselectable]="false"
      [options]="monthFilterOptions$ | async" [disabled]="!(months$ | async).length" [(ngModel)]="month"
      (valueChange)="onChangeMonth($event)" [clearable]="false">
    </atlas-field-select>
  </ng-container>

  <ng-container *ngIf="isMobile$ | async">

    <atlas-field [widthValue]="270" *dsp-content-filter [fullWidth]="(isMobile$ | async)"
      [size]="(isMobile$ | async) ? sizeSmall : sizeMedium">
      <atlas-field-label>As at</atlas-field-label>
      <input [(ngModel)]="asAt" [min]="minDate$ | async" [max]="maxDate$ | async" atlasInput [Datepicker]="pickerAsAt"
        placeholder="MM/DD/YYYY" [readonly]="true" (ngModelChange)="onChangeAsAt($event)" />
      <atlas-field-suffix>
        <datepicker-toggle [datepicker]="pickerAsAt"></datepicker-toggle>
      </atlas-field-suffix>
      <datepicker #pickerAsAt>
      </datepicker>
    </atlas-field>
  </ng-container>

  <div dsp-content>
    <ng-container *ngIf="!(isMobile$ | async)">
      <div class="row">
        <div class="columns">
          <div class="dsp-title-container">

            <atlas-icon class="performance-icon" [icon]="'icon-statistics-24'" size="large" color="primary"
              [alt]="'Performance'">
            </atlas-icon>
            <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none mos-u-spacer--padding-left-sm">
              {{ (option$ | async) === 'total' ? 'Total Returns' : 'Excess
              Returns' }}
              over 1m, 3m, CYTD, FYTD, 1, 3, 5, 7, 10 yr
              ({{ type$ | async | titlecase }} of Fees)

            </h3>
            <atlas-icon *ngIf="(notes$ | async)?.performance['chart'] !== undefined"
              #performanceChartTooltip="haloTooltip"
              (click)="performanceChartTooltip.toggle(); $event.stopPropagation()"
              class="mos-u-spacer--margin-left-xxsm dsp-performance-tooltip-trigger" [haloTooltipWithArrow]="true"
              [haloTooltip]="(notes$ | async)?.performance['chart']"
              [haloTooltipPosition]="(isMobile$ | async) ? 'top' : 'right'" [haloTooltipShowDelay]="100"
              [haloTooltipTouchGestures]="'on'"
              [haloTooltipClass]="(isMobile$ | async) ? 'dsp-performance-mobile-tooltip' : null"
              [id]="'performance-note-icon'" [size]="'small'" [icon]="'c-info'" [collection]="'user-interface'"
              [alt]="'info'">
            </atlas-icon>
          </div>
          <p *ngIf="(date$ | async) && (table$ | async).length" [id]="'performance-as-at-date'" class="dsp-subtitle">
            as at end of {{ date$ | async }}
          </p>
        </div>
        <div class="columns shrink" [style.margin-left]="'auto'" *ngIf="(table$ | async)?.length > 0">
          <atlas-dropdown #performanceDropdown="atlasDropdown" [iconSize]="sizeMedium"
            [id]="'performance-export-settings-button'" [icon]="'more_vert'" [placement]="dropdownPlacementLeftStart"
            [iconButtonAlt]="'More options'" [iconAriaTitle]="'More options'"
            [triggerType]="dropdownTriggerTypeIconButton">
            <atlas-menu [style.display]="'block'" [style.max-width]="'fit-content'">
              <atlas-menu-item *ngIf="!(drilldown$ | async)"
                (click)="performanceDropdown.menu?.closeMenu($event); onChangeType()">
                <a [id]="'performance-toggle-gross-net'">
                  {{ ((type$ | async) === performanceTypes.GROSS ?
                  dataLabels.netOfFees : dataLabels.grossOfFees) | titlecase }}
                </a>
              </atlas-menu-item>
              <atlas-menu-item (click)="performanceDropdown.menu?.closeMenu($event); onExportPDF()">
                <a [id]="'performance-download-button'">
                  Export as PDF
                </a>
              </atlas-menu-item>
              <atlas-menu-item (click)="performanceDropdown.menu?.closeMenu($event); onExportCSV()">
                <a [id]="'performance-export-button'">
                  Export as CSV
                </a>
              </atlas-menu-item>
            </atlas-menu>
          </atlas-dropdown>
        </div>
      </div>

      <div class="row mos-u-spacer--padding-bottom-md">
        <div class="column dsp-chart-container" [ngClass]="{ 'mos-u-align-center--both': !(table$ | async).length }">
          <div dsp-chart #performanceChart [id]="'performance-chart'" *ngIf="(table$ | async).length"
            [chart]="chart$ | async" class="dsp-chart"></div>
          <h3 *ngIf="!(table$ | async).length" [id]="'performance-chart-no-data'">
            No Data Available
          </h3>
        </div>
      </div>
    </ng-container>

    <div class="row">
      <div class="columns">
        <div class="dsp-title-container">

          <atlas-icon class="performance-icon" [icon]="'icon-webpage-24'" [size]="'large'" [color]="'brand'"
            [alt]="'Performance Details'">
          </atlas-icon>
          <h3 class=" mos-u-spacer--margin-none mos-u-spacer--padding-left-sm">
            Performance Details ({{ type$ | async | titlecase }} of Fees)
          </h3>
          <atlas-icon *ngIf="(notes$ | async)?.performance['table'] !== undefined"
            #performanceTableTooltip="haloTooltip" (click)="performanceTableTooltip.toggle(); $event.stopPropagation()"
            class="mos-u-spacer--margin-left-xxsm dsp-performance-tooltip-trigger" [haloTooltipWithArrow]="true"
            [haloTooltip]="(notes$ | async)?.performance['table']"
            [haloTooltipPosition]="(isMobile$ | async) ? 'top' : 'right'" [haloTooltipShowDelay]="100"
            [haloTooltipTouchGestures]="'on'"
            [haloTooltipClass]="(isMobile$ | async) ? 'dsp-performance-mobile-tooltip' : null"
            [id]="'performance-note-icon'" [size]="'small'" [icon]="'c-info'" [collection]="'user-interface'"
            [alt]="'info'">
          </atlas-icon>
        </div>
        <p *ngIf="(date$ | async) && (table$ | async).length" [id]="'performance-details-as-at-date'"
          class="dsp-subtitle">
          as at end of {{ date$ | async }}
        </p>
      </div>

      <div *ngIf="isMobile$ | async" class="columns shrink" [style.margin-left]="'auto'">
        <atlas-dropdown #performanceMobileDropdown="atlasDropdown" [iconSize]="sizeMedium"
          [id]="'performance-export-settings-button'" [icon]="'more_vert'" [placement]="dropdownPlacementLeftStart"
          [iconButtonAlt]="'More options'" [iconAriaTitle]="'More options'"
          [triggerType]="dropdownTriggerTypeIconButton">
          <atlas-menu [style.display]="'block'" [style.max-width]="'fit-content'">
            <atlas-menu-item *ngIf="!(drilldown$ | async)"
              (click)="performanceMobileDropdown.menu?.closeMenu($event); onChangeType()">
              <a [id]="'performance-toggle-gross-net'">
                {{ ((type$ | async) === performanceTypes.GROSS ?
                dataLabels.netOfFees : dataLabels.grossOfFees) | titlecase }}
              </a>
            </atlas-menu-item>
          </atlas-menu>
        </atlas-dropdown>
      </div>
    </div>

    <div class="row">
      <div class="columns" [style.min-height.px]="330"
        [ngClass]="{ 'mos-u-align-center--both': !(table$ | async).length }">
        <atlas-table *ngIf="(table$ | async).length" [customSort]="true">

          <thead atlas-table-header #header (sortOptionsDidChange)="onSort($event)">
            <tr atlas-table-row>
              <th atlas-table-header-cell *ngFor="let col of headers" [columnDef]="col">
                {{ col.name }}
              </th>
            </tr>
          </thead>
          <tbody atlas-table-body>
            <!-- <tr halo-table-row *ngFor="let row of table$ | async; let index = index"
              [ngClass]="{'benchmark-row': row.parent, 'last-benchmark-row': row.isLastBenchmark}"> -->
            <tr halo-table-row *ngFor="let row of table$ | async; let index = index">

              <ng-container *ngIf="!row.parent">
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight dsp-highlight-border': row.selected||highlightAllFunds,'dsp-secondary-highlight ': highlightAllFunds && index!==0 }">
                  {{ row.name }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight': row.selected,'dsp-secondary-highlight': highlightAllFunds && index!==0 }"
                  class="mos-u-text-right ">
                  {{ row[ '1m' ] ? (row[ '1m' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight': row.selected,'dsp-secondary-highlight': highlightAllFunds && index!==0 }"
                  class="mos-u-text-right ">
                  {{ row[ '3m' ] ? (row[ '3m' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight': row.selected,'dsp-secondary-highlight': highlightAllFunds && index!==0 }"
                  class="mos-u-text-right ">
                  {{ row[ 'CYTD' ] ? (row[ 'CYTD' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight': row.selected,'dsp-secondary-highlight': highlightAllFunds && index!==0 }"
                  class="mos-u-text-right ">
                  {{ row[ 'FYTD' ] ? (row[ 'FYTD' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight': row.selected,'dsp-secondary-highlight': highlightAllFunds && index!==0 }"
                  class="mos-u-text-right ">
                  {{ row[ '1y' ] ? (row[ '1y' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight': row.selected,'dsp-secondary-highlight': highlightAllFunds && index!==0 }"
                  class="mos-u-text-right ">
                  {{ row[ '3y' ] ? (row[ '3y' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight': row.selected,'dsp-secondary-highlight': highlightAllFunds && index!==0 }"
                  class="mos-u-text-right ">
                  {{ row[ '5y' ] ? (row[ '5y' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight': row.selected,'dsp-secondary-highlight': highlightAllFunds && index!==0 }"
                  class="mos-u-text-right ">
                  {{ row[ '7y' ] ? (row[ '7y' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-row-border': index !== 0, 'dsp-primary-highlight': row.selected,'dsp-secondary-highlight': highlightAllFunds && index!==0 }"
                  class="mos-u-text-right ">
                  {{ row[ '10y' ] ? (row[ '10y' ] | decimal) : '-' }}
                </td>
              </ng-container>
              <ng-container *ngIf="row.parent">
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight dsp-highlight-border': row.selected || highlightAllFunds}">
                  <span class="benchmark-name-cell">
                    {{ row.name }}

                    <atlas-icon *ngIf="row.tooltip !== undefined" class="mos-u-spacer--margin-left-xxsm"
                      #performanceBenchmarkTooltip="haloTooltip"
                      (click)="performanceBenchmarkTooltip.toggle(); $event.stopPropagation()"
                      [haloTooltipWithArrow]="true" [haloTooltip]="row.name"
                      [haloTooltipPosition]="(isMobile$ | async) ? 'top' : 'right'" [haloTooltipShowDelay]="100"
                      [haloTooltipTouchGestures]="'on'"
                      [haloTooltipClass]="(isMobile$ | async) ? 'dsp-performance-mobile-tooltip' : null"
                      [id]="'performance-benchmark-name-icon-' + index" size="small" [icon]="'c-info'"
                      [collection]="'user-interface'" [size]="'small'" [alt]="'info'">
                    </atlas-icon>
                  </span>
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight': row.selected || highlightAllFunds }"
                  class="mos-u-text-right ">
                  {{ row[ '1m' ] ? (row[ '1m' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight': row.selected || highlightAllFunds }"
                  class="mos-u-text-right ">
                  {{ row[ '3m' ] ? (row[ '3m' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight': row.selected || highlightAllFunds}"
                  class="mos-u-text-right ">
                  {{ row[ 'CYTD' ] ? (row[ 'CYTD' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight': row.selected || highlightAllFunds}"
                  class="mos-u-text-right ">
                  {{ row[ 'FYTD' ] ? (row[ 'FYTD' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight': row.selected || highlightAllFunds}"
                  class="mos-u-text-right ">
                  {{ row[ '1y' ] ? (row[ '1y' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight': row.selected || highlightAllFunds}"
                  class="mos-u-text-right ">
                  {{ row[ '3y' ] ? (row[ '3y' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight': row.selected || highlightAllFunds}"
                  class="mos-u-text-right ">
                  {{ row[ '5y' ] ? (row[ '5y' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight': row.selected || highlightAllFunds}"
                  class="mos-u-text-right ">
                  {{ row[ '7y' ] ? (row[ '7y' ] | decimal) : '-' }}
                </td>
                <td atlas-table-cell
                  [ngClass]="{ 'dsp-table-row': !row.selected, 'dsp-secondary-highlight': row.selected || highlightAllFunds}"
                  class="mos-u-text-right ">
                  {{ row[ '10y' ] ? (row[ '10y' ] | decimal) : '-' }}
                </td>
              </ng-container>

            </tr>
          </tbody>
        </atlas-table>
        <div *ngIf="(table$ | async).length" class="column medium-3 pagination-container"
          style="justify-content: left;">
          <ng-container *ngIf="table$ | async as tableRows">
            <span>
              Showing 1 to {{ getFundCount(tableRows) }} of {{ getFundCount(tableRows) }} entries
            </span>
          </ng-container>
        </div>
        <!-- <div *ngIf="(table$ | async).length" class="mos-u-spacer--margin-top-sm">
          <atlas-pagination [paginationInfo]="pagination$ | async">
          </atlas-pagination>
        </div> -->
        <h3 *ngIf="!(table$ | async).length" [id]="'performance-no-data'">
          No Data Available
        </h3>
      </div>
    </div>
  </div>
</dsp-content-card>